import '../index.scss';
import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
// import LabeledTextarea from '../../shared/components/labeled-textarea';
// import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getClaimDetails } from '../repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';


class ClaimRelatedDetails extends Component {

    state = {
        claimDetails: [],
        claimComments: '',
    };


    componentWillMount = () => {

        this.loadDefault( this.props.claimNumber );

    }

    componentWillReceiveProps ( nextProps ) {

        if ( nextProps.claimNumber !== this.props.claimNumber ) {

            this.loadDefault( nextProps.claimNumber );

        } else if ( nextProps.userDesiredLng !== this.props.userDesiredLng ) {

            this.loadUpdated( nextProps.userDesiredLng );

        }


    }

    loadDefault = warrantyClaimId => {


        getClaimDetails( this.props.claimFor, warrantyClaimId ).then( response => {


            this.setState( {
                claimDetails: response,
            }, this.loadUpdated );

        } ).catch( () => {


        } );

    }


    loadUpdated = ( userDesiredLng = this.props.userDesiredLng ) => {

        var multiple_lang = "";
        var multiple_lang1 = "";
        var multiple_lang2 = "";
        var multiple_lang3 = "";
        var multiple_lang4 = "";
        var multiple_lang5 = "";
        var multiple_lang6 = "";
        var multiple_iso = [];
        var newarray = [];
        var counter = 0
        if ( this.state.claimDetails.length > 0 ) {

            ( this.state.claimDetails ).forEach( item => {
                    newarray = this.state.claimDetails[counter]
                    multiple_lang1 = "<b><u>"
                    multiple_lang2 = newarray.isoLanguageCode
                    multiple_lang3 = "</b></u><p>"
                    multiple_lang4 = newarray.primePartDetailText
                    multiple_lang5 = "</p>"
                    multiple_lang6 = [multiple_lang1+multiple_lang2+multiple_lang3+multiple_lang4+multiple_lang5]
                    counter = counter+1
                    multiple_lang = [multiple_lang+multiple_lang6]
            } );
            this.setState({
                isoLanguageCode: multiple_iso,
                primePartDetailText: multiple_lang,
              });
        }
    }
    render () {

        return (
            
            <div className="basic-claim">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <section className="claim-complaints">
                    <div className = "rows">
                        <div dangerouslySetInnerHTML={{__html:this.state.primePartDetailText}}/>
                    </div>
                </section>
            </div>
        );

    }

}
ClaimRelatedDetails.displayName = 'ClaimRelatedDetails';
ClaimRelatedDetails.propTypes = {
    claimNumber: PropTypes.string.isRequired,
    claimFor: PropTypes.string.isRequired,
    claimTextEdit: PropTypes.func.isRequired,
    isComponentEdit: PropTypes.bool.isRequired,
    // userDesiredLng: PropTypes.string,
    enableEditCmp: PropTypes.func,
    isEdit: PropTypes.bool.isRequired,
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    primePartNumber: PropTypes.object.isRequired,
    // handleLanguage: PropTypes.func.isRequired,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
} );
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) ),
} );
export default connect( mapStateToProps, mapDispatchToProps )( ClaimRelatedDetails );
